import Levante1 from '../../../media/GW/Levante.webp'
import Levante2 from '../../../media/GW/Levante.webp'


const Levanteimages =[
Levante1,Levante2
]

export default Levanteimages;